import React from 'react';

import { TrackingType } from '~/src/common/consumption/completion-snackbar';

import type { Content } from '../types';

import { useNavigateFromDurationCarouselAnalytics } from './useNavigateFromDurationCarouselAnalytics';
import { useOnMinuteConsumedAnalytics } from './useOnMinuteConsumedAnalytics';
import { useOnSecondConsumedAnalytics } from './useOnSecondConsumedAnalytics';
import { YouboraAnalytics } from './YouboraAnalytics';

export const Analytics: React.FC<{
  trackingType?: TrackingType;
  content: Content;
  indexName: string;
  contentTag?: string | null;
}> = ({ trackingType, content, indexName, contentTag }) => {
  useOnSecondConsumedAnalytics({ content });
  useOnMinuteConsumedAnalytics({ content, trackingType, indexName, contentTag });

  useNavigateFromDurationCarouselAnalytics({ content });

  return <YouboraAnalytics trackingType={trackingType} content={content} contentTag={contentTag} />;
};
